"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudienceStatusToJSON = exports.AudienceStatusFromJSONTyped = exports.AudienceStatusFromJSON = exports.AudienceStatus = void 0;
/**
 * Status of the audience.
 * @export
 */
exports.AudienceStatus = {
    Archived: 'ARCHIVED',
    Processing: 'PROCESSING',
    Empty: 'EMPTY',
    Bookable: 'BOOKABLE',
    Live: 'LIVE'
};
function AudienceStatusFromJSON(json) {
    return AudienceStatusFromJSONTyped(json, false);
}
exports.AudienceStatusFromJSON = AudienceStatusFromJSON;
function AudienceStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AudienceStatusFromJSONTyped = AudienceStatusFromJSONTyped;
function AudienceStatusToJSON(value) {
    return value;
}
exports.AudienceStatusToJSON = AudienceStatusToJSON;
